import { BaseModel } from '../email-template/base-model.interface';
import BlockModel from '../email-template/block-model.interface';
import { NotificationInitVariables } from '../template/notifications-model.interface';

export interface MetaSingleImageAccountTypeModel extends BaseModel {
  variables?: { [key: string]: string } | MetaSingleImageAccountTypeVariables;
}

export interface MetaSingleImageAccountTypeVariables {
  AccountType: string;
}

export class MetaSingleImageAccountTypeInitVariables implements MetaSingleImageAccountTypeVariables {
  AccountType = '';
}

export class MetaSingleImageAccountTypeInitModel implements BlockModel {
  blockId: string = '';
  count: number = 0;
  name: string = '';
  variables: { [key: string]: string };
  notifications: NotificationInitVariables[];

  constructor() {
    const initVars = new MetaSingleImageAccountTypeInitVariables();
    this.variables = { ...initVars };
    this.notifications = [new NotificationInitVariables()];
  }
}